import { createSlice } from "@reduxjs/toolkit";
import { PayloadAction } from "@reduxjs/toolkit";
import { message } from "antd";
import API from "../../api"
const {homePageBottomSliderList,homePageBottomSliderAdd,homePageBottomSliderUpdate,homePageBottomSliderDelete,homePageBottomSliderEdit}=API

const initialState = { 
    data:[],
    singleHomePageBottomSlider:[],
    error: null, 
    loading:false,
    message:'',
    deleteLoad:false,
    editData:[]
}

const homePageBottomSliderSlice = createSlice({
    name: "homePageBottomSlider",
    initialState,
    reducers: {
      setData(state,action){
          state.data=action.payload;
      },
      setLoading(state, action) {
          state.loading = action.payload;
        },
      setMessage(state,action){
          state.message=action.payload;
      },
      setError(state,action){
          state.error=action.payload;
    },
      setDeleteLoad(state,action){
          state.deleteLoad=action.payload
      },
      setAfterDeleteHomePageBottomSlider(state,action){
          state.data=state.data.filter((item)=>item._id !== action.payload)
      },
      setHomePageBottomSliderAdd(state,action){
          state.data=[action.payload,...state.data]
      },
      setEditHomePageBottomSlider(state,action){
          state.singleHomePageBottomSlider=state.data.filter((item)=>item._id === action.payload)
      },
      setBlankSingleData(state,action){
        state.singleHomePageBottomSlider=[]
      },
      setEditData(state,action){
          state.editData=action.payload
      }
    },
  });
  
  export const {setEditData, setLoading, setMessage,setError,setData,setDeleteLoad,setHomePageBottomSliderAdd,setAfterDeleteHomePageBottomSlider,setEditHomePageBottomSlider,setBlankSingleData} = homePageBottomSliderSlice.actions;
  export default homePageBottomSliderSlice.reducer;

  export const getHomePageBottomSliderData = () => async (dispatch) => {
         dispatch(setLoading(true));
    try {
      const res= await homePageBottomSliderList()
      if (res.data.success) {
          dispatch(setData(res.data.data[0]?.fieldvalue))
          dispatch(setLoading(false));
          dispatch(setMessage(res.data.message))
      } else {
          dispatch(setLoading(false));
          dispatch(setError(res.data.message));
      }
    } catch (e){
      dispatch(setLoading(false));
      dispatch(setError(e.message));
      message.error(e.message);
    }
  };
  export const homePageBottomSliderDataAdded=(data) => async (dispatch)=>{
    dispatch(setDeleteLoad(true));
    try{
      const res= await homePageBottomSliderAdd(data)
      if(res.data.success) {
         dispatch(setHomePageBottomSliderAdd(data))
         dispatch(setDeleteLoad(false))
         dispatch(setMessage(res.data.message))
         message.success(res.data?.message);
      } else {
        dispatch(setDeleteLoad(false));
        dispatch(setError(res.data.message));
        message.error(res.data.message);
    }
    } catch(e){
      dispatch(setDeleteLoad(false));
      dispatch(setError(e.response.data.message));
      message.error(e.response.data.message);
    }
}

export const sigleHomePageBottomSliderDataAction=(id) =>(dispatch)=>{
              dispatch(setEditHomePageBottomSlider(id))
}
export const blankDataAction=() =>(dispatch)=>{
  dispatch(setBlankSingleData())
}
export const homePageBottomSliderDataUpdate=(id,data) => async (dispatch)=>{
  dispatch(setDeleteLoad(true));
  try{
    const res= await homePageBottomSliderUpdate(id,data)
    if(res.data.success) {
       dispatch(setBlankSingleData())
       dispatch(setEditData())
       dispatch(setDeleteLoad(false))
       dispatch(setMessage(res.data.message))
       message.success(res.data?.message);
    } else {
      dispatch(setDeleteLoad(false));
      dispatch(setError(res.data.message));
      message.error(res.data.message);
  }
  } catch(e){
    dispatch(setDeleteLoad(false));
    dispatch(setError(e.response.data.message));
    message.error(e.response.data.message);
  }
}
export const homePageBottomSliderEditAction=(id,field) => async (dispatch)=>{
  try{
    const res= await homePageBottomSliderEdit(id,field)
    if(res.data.success) {
       dispatch(setEditData(res.data.data))
    } else {
      message.error(res.data.message);
  }
  } catch(e){
    message.error(e.response.data.message);
  }
}
export const editBlankData=() =>(dispatch)=>{
        dispatch(setEditData())
}
  export const homePageBottomSliderDataDelete=(id) => async (dispatch)=>{
          dispatch(setDeleteLoad(true));
          try{
            const res= await homePageBottomSliderDelete(id)
            if(res.data.success) {
               dispatch(setAfterDeleteHomePageBottomSlider(id))
               dispatch(setDeleteLoad(false))
               dispatch(setMessage(res.data.message))
               message.success(res.data?.message);
            } else {
              dispatch(setDeleteLoad(false));
              dispatch(setError(res.data.message));
              message.error(res.data.message);
          }
          } catch(e){
            dispatch(setDeleteLoad(false));
            dispatch(setError(e.response.data.message));
            message.error(e.response.data.message);
          }
  }